import {
  ICreateUpdateStaffRequestPayload,
  ICreateUpdateWarehouseStaffUserNormalizedReq, ICreateWarehouseStaffUserRequestPayload, IMultiSelectDropdownPayload,
  IWarehousePayload,
  IWarehouseStaffListingResponse
} from "../interfaces/Index";
import {IAddUpdateWarehouseStaffPageState} from "../components/pages/warehouseStaff/WarehouseStaff.interface";


export const normalizeWarehouseResponseForDropdown = (
    warehouses: IWarehousePayload[]
) => {
  return warehouses.map((warehouse: IWarehousePayload) => {
    return {
      ...warehouse,
      key: warehouse.id,
      title: warehouse.name,
      label: warehouse.name,
    };
  });
};

export const normalizeWarehouseStaffUserUpdatePayload = (
    req: IAddUpdateWarehouseStaffPageState
): ICreateUpdateWarehouseStaffUserNormalizedReq => {
  const payload: ICreateUpdateWarehouseStaffUserNormalizedReq = {
    id: req.id,
    userId: req.userId,
    fullName: req.fullName,
    title: req.title ? req.title : "BAZAAR_STAFF",
    nationalId: req.cnic,
    email: req.email,
    status: "ACTIVE",
    phoneNumber: req.phoneNumber,
    warehouseId: req.warehouseId,
    jobTypes: req.jobTypesList.map((jobType) => jobType.title)
  };

  return payload;
};

export const normalizeCreateStaffPayload = (
    req: IAddUpdateWarehouseStaffPageState
): ICreateUpdateStaffRequestPayload => {
  const payload: ICreateUpdateStaffRequestPayload = {
    userId: req.userId,
    title: req.title ? req.title : "BAZAAR_STAFF",
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    status: req.status ? "ACTIVE" : "INACTIVE",
    warehouseId: req.warehouseId,
    jobTypes: req.jobTypesList.map((jobType) => jobType.title)
  };

  return payload;
};

export const normalizeWarehouseStaffUserCreatePayload = (
    req: IAddUpdateWarehouseStaffPageState
): ICreateWarehouseStaffUserRequestPayload => {

  return {
    id: req.id,
    userId: req.userId,
    title: req.title ? req.title : "BAZAAR_STAFF",
    fullName: req.fullName,
    phoneNumber: req.phoneNumber,
    status: req.status ? "ACTIVE" : "INACTIVE",
    password: req.password,
    confirmPassword: req.confirmPassword,
    nationalId: req.cnic,
    email: req.email,
    warehouseId: req.warehouseId,
    jobTypes: req.jobTypesList.map((jobType) => jobType.title)
  };
};

export const normalizeWareHouseNames = (
    wareHouseNames: any
): IWarehousePayload[] => {
  return wareHouseNames.map((data: any) => {
    return {
      id: data.id,
      name: data.name,
      latitude: data.latitude,
      longitude: data.longitude,
    };
  });
};

export const normalizeJobTypesForDropdown = (
    jobTypes: string[]
): IMultiSelectDropdownPayload[] => {

  return jobTypes.map((jobType: string) => {
    return {
      key: jobType,
      title: jobType,
      label: jobType,
    };
  });
};

